// src/components/VersionInfo.tsx
import { useEffect, useState } from 'react';


const version = String(process.env.REACT_APP_RELEASE_VERSION  || '');

const VersionInfo = () => {

  const [subVersion, setSubVersion] = useState('');

  useEffect(() => {
    fetch('/version.json')
      .then((res) => res.json())
      .then((data) => {
        if(data.version) {
          setSubVersion(`(${data.version})`);
        }
      })
      .catch(() => setSubVersion(''));
  }, []);

  return (
    <>
      {version && <span className='version-info'>Release: {`${version} ${subVersion}`}</span>}
    </>
  );
};

export default VersionInfo;
